
export interface Achievement {
  id: string;
  name: string;
  description: string;
  icon: string;
  xp: number;
  tier: 'bronze' | 'silver' | 'gold' | 'platinum';
  condition: (user: any) => boolean;
}

export const ACHIEVEMENTS: Achievement[] = [
  // Daily Achievements
  {
    id: 'first_blood',
    name: 'First Blood',
    description: 'Complete your first exercise',
    icon: '🎯',
    xp: 50,
    tier: 'bronze',
    condition: (user) => user.stats.exercisesCompleted >= 1
  },
  {
    id: 'streak_7',
    name: 'Week Warrior',
    description: 'Maintain a 7-day streak',
    icon: '🔥',
    xp: 500,
    tier: 'silver',
    condition: (user) => user.stats.streak >= 7
  },
  {
    id: 'streak_30',
    name: 'Month Master',
    description: 'Maintain a 30-day streak',
    icon: '👑',
    xp: 2000,
    tier: 'gold',
    condition: (user) => user.stats.streak >= 30
  },
  
  // Performance Achievements
  {
    id: 'perfect_reading',
    name: 'Eagle Eye',
    description: 'Score 100% on a reading passage',
    icon: '👁️',
    xp: 200,
    tier: 'silver',
    condition: (user) => user.stats.perfectReadings >= 1
  },
  {
    id: 'speed_demon',
    name: 'Speed Demon',
    description: 'Achieve 500 WPM reading speed',
    icon: '⚡',
    xp: 300,
    tier: 'gold',
    condition: (user) => user.stats.maxReadingSpeed >= 500
  },
  
  // Milestone Achievements
  {
    id: 'hundred_club',
    name: 'Century',
    description: 'Complete 100 exercises',
    icon: '💯',
    xp: 1000,
    tier: 'gold',
    condition: (user) => user.stats.exercisesCompleted >= 100
  },
  {
    id: 'vocab_1000',
    name: 'Word Lord',
    description: 'Master 1000 vocabulary words',
    icon: '📚',
    xp: 3000,
    tier: 'platinum',
    condition: (user) => user.stats.vocabMastered >= 1000
  }
];
